<div class="body_wrap dashboard_body">
  <!-- <div class="sticky-top sticky-offset">
    <div class="top_menu">
      <button mat-button class="d-md-none d-none"><img src="../../assets/images/menu.svg" /></button>
    </div>
  </div> -->
  <div class="dash_base">
    <div class="container mt-40">
      <div class="whiteWrap">
        <div class="titleWrap">
          <div class="row w-100">
            <div class="col-sm-12">
              <h4 class="mt-1 d-inline-block">
                {{ 'Automated Recommendations' }}
              </h4>
            </div>
          </div>
        </div>
        <app-marketing-effectiveness></app-marketing-effectiveness>
      </div>
    </div>
  </div>
</div>
